
import { motion } from 'framer-motion';

export const BusinessVisuals = () => {
    return (
        <div className="w-full h-full bg-white relative overflow-hidden flex flex-col items-center justify-center p-8 font-jakarta">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-[0.02]"
                style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, black 1px, transparent 0)', backgroundSize: '20px 20px' }}>
            </div>

            <div className="relative w-full max-w-[540px]">
                {/* Main Dashboard / Report View */}
                <motion.div
                    initial={{ scale: 0.95, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="w-full bg-white rounded-xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] border border-gray-200 p-8 z-10 relative"
                >
                    {/* Header */}
                    <div className="flex justify-between items-center mb-8 border-b border-gray-100 pb-5">
                        <div className="space-y-1">
                            <h3 className="text-lg font-bold text-gray-900">Q3 Performance Report</h3>
                            <p className="text-xs text-gray-500 font-medium">Prepared for <span className="text-gray-800">Executive Team</span></p>
                        </div>
                        <div className="flex -space-x-3">
                            {[1, 2, 3].map(i => (
                                <div key={i} className={`w-9 h-9 rounded-full border-[2px] border-white flex items-center justify-center text-[10px] font-bold text-white shadow-sm ring-1 ring-gray-100`}
                                    style={{ backgroundColor: i === 1 ? '#2563EB' : i === 2 ? '#64748B' : '#94A3B8' }}>
                                    {String.fromCharCode(64 + i)}
                                </div>
                            ))}
                            <div className="w-9 h-9 rounded-full border-[2px] border-white bg-gray-50 flex items-center justify-center text-[10px] font-bold text-gray-500 shadow-sm ring-1 ring-gray-100">
                                +4
                            </div>
                        </div>
                    </div>

                    {/* Report Content */}
                    <div className="space-y-8">
                        {/* Highlights Section */}
                        <div className="flex gap-6">
                            <div className="flex-1 space-y-4">
                                <div className="space-y-2">
                                    <div className="h-2 w-full bg-gray-100 rounded-full" />
                                    <div className="h-2 w-5/6 bg-gray-100 rounded-full" />
                                    <div className="h-2 w-4/6 bg-gray-100 rounded-full" />
                                </div>
                                <div className="flex gap-2 mt-2">
                                    <span className="bg-green-50 text-green-700 text-[10px] font-bold px-2 py-1 rounded-md border border-green-100">Exceeded Targets</span>
                                    <span className="bg-blue-50 text-blue-700 text-[10px] font-bold px-2 py-1 rounded-md border border-blue-100">Market Leader</span>
                                </div>
                            </div>

                            {/* Visual Chart */}
                            <div className="w-1/3 h-24 bg-white rounded-lg border border-gray-200 relative overflow-hidden group p-3 flex flex-col justify-between shadow-sm">
                                <div className="text-[10px] font-bold text-gray-400 uppercase">Growth</div>
                                <div className="relative h-12 flex items-end justify-between gap-1">
                                    {[30, 50, 45, 70, 90].map((h, i) => (
                                        <motion.div
                                            key={i}
                                            initial={{ height: 0 }}
                                            animate={{ height: `${h}%` }}
                                            transition={{ delay: 0.5 + (i * 0.1), duration: 0.5 }}
                                            className="w-full bg-blue-500 rounded-t-[2px]"
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* KPI Grid */}
                        <div className="grid grid-cols-3 gap-4 pt-2">
                            {[
                                { label: 'Revenue', value: '$2.4M', color: 'bg-blue-600' },
                                { label: 'Customers', value: '1,240', color: 'bg-indigo-600' },
                                { label: 'Satisfaction', value: '98%', color: 'bg-gray-800' }
                            ].map((kpi, i) => (
                                <motion.div
                                    key={i}
                                    initial={{ y: 10, opacity: 0 }}
                                    animate={{ y: 0, opacity: 1 }}
                                    transition={{ delay: 0.5 + (i * 0.1) }}
                                    className="bg-gray-50 rounded-lg p-3 border border-gray-100"
                                >
                                    <div className="text-[10px] text-gray-500 font-bold uppercase mb-1">{kpi.label}</div>
                                    <div className="text-lg font-bold text-gray-900">{kpi.value}</div>
                                    <div className={`mt-2 h-1 w-full bg-gray-200 rounded-full overflow-hidden`}>
                                        <div className={`h-full ${kpi.color} w-[70%]`} />
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>
                </motion.div>

                {/* Floating "Approved" Stamp */}
                <motion.div
                    initial={{ scale: 2, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ delay: 1, type: "spring" }}
                    className="absolute -top-5 -right-5 bg-[#22c55e] text-white w-20 h-20 rounded-full flex items-center justify-center font-black text-[11px] transform rotate-12 shadow-[0_10px_20px_rgba(34,197,94,0.3)] border-[4px] border-white z-20 tracking-wider"
                >
                    APPROVED
                </motion.div>

                {/* Team Badge */}
                <motion.div
                    initial={{ x: -20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.8 }}
                    className="absolute -left-8 top-1/2 bg-white px-5 py-3 rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.08)] border border-gray-100 z-30 flex items-center gap-3"
                >
                    <div className="w-2.5 h-2.5 bg-blue-600 rounded-full animate-pulse" />
                    <span className="text-sm font-bold text-gray-800">Final_Draft_v2.pdf</span>
                </motion.div>
            </div>
        </div>
    );
};
